import thumbnail from '../../../../images/report_thumbnail_tooling.png';
import { ReportV2Dto } from '../../../api';
import { DatasetSlugs } from '../../dataset';

const dimensionsWithDescriptions = [
    {
        key: 'creative_development_agency_percentage',
        title: 'Percentage of creative development executed by an agency',
        description: null,
    },
    {
        key: 'current_creative_projects',
        title: 'Types of creative projects currently working on',
        description: null,
    },
    {
        key: 'brand_building_vs_growth',
        title: 'Focus on brand-building vs growth/performance',
        description: null,
    },
    {
        key: 'marketing_budget_for_creative_production',
        title: 'Percentage of marketing budget dedicated to creative production',
        description: null,
    },
    {
        key: 'inspiration_for_creatives',
        title: 'Sources of inspiration for creatives',
        description: null,
    },
];

export const CreativeStrategyReport: ReportV2Dto = {
    id: 'creative_strategy',
    name: 'Creative Strategy',
    tagline: null,
    description: `Learn how other companies are approaching creative production (in-house vs. agency, frequency of new ads, etc.)`,
    category: 'marketing',
    dataset: DatasetSlugs.CREATIVE_STRATEGY,
    traits: [],
    tags: ['strategy', 'trends'],
    dependencies: [
        {
            kind: 'survey',
            dataset: DatasetSlugs.CREATIVE_STRATEGY,
        },
    ],
    thumbnail: {
        description: null,
        url: thumbnail,
    },
    images: [
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
        {
            description: null,
            url: 'https://placehold.co/1600x800@3x',
        },
    ],
    visualizations: dimensionsWithDescriptions.map((dimension) => ({
        key: dimension.key,
        kind: 'bar', // Assuming bar charts for all dimensions. Adjust as needed.
        name: dimension.title, // Name of the visualization
        description: dimension.description,
        aggregation: 'count', // Assuming count for all dimensions. Adjust as needed.
        breakdown: {
            keys: [dimension.key],
        },
    })),
};
